module.exports = __webpack_public_path__ + "static/eric-resendiz-2-0b0e02953f67254fdc5813d5d3c1b825.jpg";